import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../ExamPicker.css';
import './panels.css';

function ExamListPanel({ type, apiUrl, onSelect }) {
  const [papers, setPapers] = useState([]);
  const [pastAttempts, setPastAttempts] = useState([]);
  const [loading, setLoading] = useState(true);

  const listEndpoint = type === 'mini' ? 'mini-mocks' : 'full-mocks';
  const idField = type === 'mini' ? 'mini_mock_id' : 'full_mock_id';

  useEffect(() => {
    setLoading(true);
    Promise.all([axios.get(`${apiUrl}/${listEndpoint}`), axios.get(`${apiUrl}/${listEndpoint}/attempts`)])
      .then(([papersRes, attemptsRes]) => {
        setPapers(papersRes.data);
        setPastAttempts(attemptsRes.data);
      })
      .catch(() => setPapers([]))
      .finally(() => setLoading(false));
  }, [type, apiUrl, listEndpoint]);

  const bestScoreFor = (paperId) => {
    const attempts = pastAttempts.filter((a) => a[idField] === paperId);
    if (attempts.length === 0) return null;
    return Math.round(Math.max(...attempts.map((a) => a.score)));
  };

  return (
    <div className="panel">
      <h2>{type === 'mini' ? 'Mini Mock Exams' : 'Full Mock Exams'}</h2>
      <p className="panel-intro">
        {type === 'mini'
          ? 'Shorter timed exams to test your knowledge across sections.'
          : 'Complete full-length exams simulating the real UCAT ANZ experience.'}
      </p>
      {loading ? (
        <div className="loading"><div className="spinner"></div>Loading papers...</div>
      ) : papers.length === 0 ? (
        <p>No papers available yet.</p>
      ) : (
        <div className="picker-grid">
          {papers.map((paper) => {
            const best = bestScoreFor(paper.id);
            return (
              <button key={paper.id} className="picker-card" onClick={() => onSelect(paper.id)}>
                <div className="picker-card-title">{paper.title}</div>
                <div className="picker-card-meta">{paper.total_questions} questions · {paper.time_limit_minutes} min</div>
                {best !== null && <div className="picker-card-best">Best score: {best}%</div>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ExamListPanel;
